















import { mapGetters } from 'vuex'

import { Component, Prop, Vue } from "vue-property-decorator";

import * as consts from '@/consts';

@Component({
  computed: mapGetters([
  'embedded'
  ])  
})export default class StudentWelcomePage extends Vue {
  created(): void {
    this.$appMgr.log('created: StudentWelcomePage');
  }

  mounted(): void {
    this.$appMgr.log('mounted: StudentWelcomePage');
  }

  destroyed(): void {
    this.$appMgr.log('destroyed: StudentWelcomePage');
  }

  gotoStudenMainPage(): void {
    // let loginResults = this.$serverMgr.getLoginResults();

    // if (loginResults.hasCleverAccount) {
    //   const dev = consts.DEV ? 'true' : 'false';
    //   const url = `https://clever-redirect.khanacademykids.org?dev=${dev}&accessToken=${loginResults.accessToken}`;      

    //   window.location.replace(url);
    // }
    // else {
      this.$router.replace({ name: 'StudentMainPage' });
    // }
  }
}
